<div
	*ngrxLet="controller.activePhaseIndex$; let activePhaseIndex"
	class="flex z-10 p-shadow"
>
	<div
		*ngFor="
			let phase of controller.phases$ | async;
			trackBy: trackByPhase;
			let isFirst = first;
			let i = index
		"
		[class.p-background-color-primary-variant-pastel]="activePhaseIndex !== i + 1"
		[class.p-background-color-primary]="activePhaseIndex === i + 1"
		(click)="onTabClick(i)"
		class="
			flex-1 flex
			h-8
			cursor-pointer
			leading-8
			text-center
			uppercase
			font-semibold
			relative
		"
	>
		<div
			[class.p-color-primary-text]="activePhaseIndex === i"
			class="absolute inset-0 truncate whitespace-nowrap pl-1 pr-3"
		>
			{{ (phase.localization$ | async)?.name }}
		</div>
		<div
			[class.p-background-color-primary-variant-pastel]="activePhaseIndex !== i"
			[class.p-background-color-primary]="activePhaseIndex === i"
			class="flex-auto"
		></div>
		<div
			[class.p-border-color-primary-variant-pastel]="activePhaseIndex !== i"
			[class.p-border-color-primary]="activePhaseIndex === i"
			class="
				flex-none
				border-w-4 border-solid border-t-transparent border-r-0 border-b-transparent
			"
		></div>
	</div>
</div>
<button
	*ngIf="controller.showLibraryButton$ | async"
	[routerLink]="controller.libraryRouterLink$ | async"
	class="p-button-secondary p-rounded p-shadow absolute bottom-2 right-2 z-10"
	icon="fas fa-plus"
	pButton
	type="button"
></button>
<spr-plan-phase *ngIf="controller.activePhase$ | async"></spr-plan-phase>
